import { render, staticRenderFns } from "./vipDetailUser.vue?vue&type=template&id=24607c5c&scoped=true"
import script from "./vipDetailUser.vue?vue&type=script&lang=js"
export * from "./vipDetailUser.vue?vue&type=script&lang=js"
import style0 from "./vipDetailUser.vue?vue&type=style&index=0&id=24607c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24607c5c",
  null
  
)

export default component.exports